import { GraphQLError } from "graphql";

export const handleGraphQLError = (graphQLError: GraphQLError): string =>
  graphQLError.extensions?.exception?.description ?? graphQLError.message;
